<template>
    <div class="w-full">
        <ul class="w-full flex justify-center items-center gap-2">
            <li
                class="w-6 h-1 rounded-sm"
                :class="{
                    'bg-slate-800': stp.step === redemptionStep,
                    'bg-slate-200': !stp.step !== redemptionStep,
                }"
                v-for="stp in steps"
                :key="stp.id"
            ></li>
        </ul>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useTripsStore } from '@/store/trips';

const tripsStore = useTripsStore();
const { steps, redemptionStep } = storeToRefs(tripsStore);
</script>
